const OpinionTypeData = {
  COMPARISON: ['Much Worse', 'Slightly Worse', 'Same', 'Slightly Better', 'Much Better'],
  AGREEMENT: [
    'Strongly Disagree',
    'Somewhat Disagree',
    'Neutral',
    'Somewhat Agree',
    'Strongly Agree'
  ],
  FREQUENCY: ['Never', 'Seldom', 'About Half the Time', 'Usually', 'Always'],
  IMPORTANCE: [
    'Not at All Important',
    'Somewhat Important',
    'Important',
    'Very Important',
    'Absolutely Critical'
  ],
  LIKELIHOOD: ['Definitely Not', 'Probably Not', 'Not Sure', 'Probably', 'Definitely'],
  QUALITY: ['Extremely Poor', 'Below Average', 'Average', 'Above Average', 'Excellent']
};

export default OpinionTypeData;
// export const options = [
//   {
//     value: 'type1',
//     label: 'type1'
//   },
//   {
//     value: 'type2',
//     label: 'type2'
//   }
// ];
